var rich_content_viewer_default = {
  "fontElementMap": "dNiy-",
  "wrapper": "wCH8c",
  "pluginContainerMobile": "_6dv1Z",
  "viewer": "wpyU-",
  "android": "JCDBU",
  "rootedTraversedContent": "yLmbU",
  "atomic": "Pqm60",
  "toolbar": "q0zlL",
  "block": "_2Mtcj"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
